<footer class="bg-background border-border border-t">
  <div
    class="container mx-auto flex flex-col items-center gap-6 px-4 py-8 lg:flex-row lg:justify-between lg:gap-4">
    <a
      href="https://schenkwerk.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Schenkwerk">
      <app-logo [widthInPx]="140" />
    </a>

    <nav aria-label="Rechtliches" class="flex flex-wrap items-center justify-center gap-1">
      @for (link of legalLinks; track link.href) {
        <a hlmBtn variant="link" size="sm" [href]="link.href" target="_blank" rel="noopener">
          {{ link.label }}
        </a>
      }
    </nav>

    <p hlmMuted class="text-center text-xs">
      © {{ currentYear }} ByteBakery UG (haftungsbeschränkt)
    </p>
  </div>
</footer>
